import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {RouterLink} from '@angular/router';

import {Product} from '../../models/product';
import {ProductService} from '../../services/product/product.service';
import {ProductNamePipe} from '../../pipes/product-name.pipe';

@Component({
  selector: 'app-out-of-stock-products-teaser',
  standalone: true,
  imports: [RouterLink, ProductNamePipe],
  templateUrl: './out-of-stock-products-teaser.component.html',
  styleUrl: './out-of-stock-products-teaser.component.scss'
})
export class OutOfStockProductsTeaserComponent implements OnInit, OnChanges {

  @Input() limit?: number;
  @Input() householdId?: number;

  products: Product[] = [];
  loading = false;

  constructor(private productService: ProductService) {
  }

  ngOnInit(): void {
    this.load();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.limit || changes.householdId) {
      this.load();
    }
  }

  private load(): void {
    const hid = this.householdId;
    if (!hid) {
      this.products = [];
      this.loading = false;
      return;
    }

    this.loading = true;
    this.productService.getAllProducts(hid, {stockStatus: 'out'}).subscribe({
      next: (prods) => {
        this.products = prods ?? [];
        if (this.limit != null && this.products.length > this.limit) {
          this.products = this.products.slice(0, this.limit);
        }
      },
      error: () => {
        this.products = [];
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  trackById(index: number, item: Product) {
    return item.id ?? index;
  }
}

